import React,{FC} from 'react'
import useFilteredProviders from 'hooks/useFiltereProviders';
import { createStyles, makeStyles } from "@mui/styles";
import { Grid,Typography,Avatar, Theme } from '@mui/material';
import { useStore } from 'store/StoreProvider';
import { ContactMessage } from 'utils/constants';

const useStyles = makeStyles((theme:Theme) =>
  createStyles({
     DRProfileBody:{
      display:"flex",
        gap:"30px",
        alignItems:"center",
        [theme.breakpoints.down('md')]:{
          textAlign:"center"
        }
     },
     avtarSize:{
      [theme.breakpoints.up('md')]:{
        height:"96px",
        width:"96px"
      }
     },
     profileTitle:{
      fontSize: "1.2428571429rem !important;",
      color:"#3D5A80 !important;",
      fontWeight:"600 !important",
      fontFamily: 'Open Sans !important', 
      [theme.breakpoints.up('md')]:{
          width:"80%"
      }
     },
      AddressTitle:{
      fontSize: "16px !important;",
      color:"#545454 !important",
      fontFamily: 'Open Sans !important', 
      [theme.breakpoints.up('md')]:{
        width:"80%"
    }
     }, 
     publicName:{
      fontSize: "16px !important;",
      color:"#2b2b2b !important",
      fontWeight:"600 !important",
      fontFamily: 'Open Sans !important', 
      [theme.breakpoints.up('md')]:{
        width:"80%"
    },
   
     },
     ContactMessage:{
      fontSize: "13px !important;",
      color:"#545454 !important",
      fontFamily: 'Open Sans !important', 
    }
  })
);
interface props{
doctorId?:number;
isUseAvtar?:boolean;
addressID?:number;
}

const DRProfile:FC<props>=({doctorId,isUseAvtar,addressID})=> {
  const classes = useStyles();
  const store = useStore();
  const data = store.getData();
  const  DRDetails =useFilteredProviders(data?.Providers,doctorId)
  const  DRAddresses =useFilteredProviders(data?.Addresses,addressID)
  return (
   <Grid className={classes.DRProfileBody}>
   {isUseAvtar&&
    <Grid>
    <Avatar alt={DRDetails?.first_name}
    src="#"
    sx={{ width: 96, height: 96 }}></Avatar>
  </Grid>}
    <Grid sx={{width:"100%"}}>
      <Grid sx={{width:{xl:"265px !important"}}}>
        <Typography variant='h6' className={classes.profileTitle}>{`${DRDetails?.first_name} ${DRDetails?.last_name}`}</Typography>
      </Grid>
      <Grid>
        <Typography variant='body2' className={classes.publicName}>{DRDetails?.public_name}</Typography>
      </Grid> 
      <Grid>
        <Typography variant='body2' className={classes.AddressTitle}>{DRAddresses?.address_line_one}</Typography>
      </Grid>
      <Grid>
        <Typography variant='body2' className={classes.AddressTitle}>{`${DRAddresses?.city}, ${DRAddresses?.state},  ${DRAddresses?.zip_code} `}</Typography>
      </Grid>
      
       <Grid>
        <Typography variant='body2' className={classes.ContactMessage}>{ContactMessage}</Typography>
      </Grid>
    </Grid>
   </Grid>
  )
}

export default DRProfile